module.exports = __webpack_public_path__ + "static/media/at.2f9f477d.svg";